import React from 'react';
import styles from './favorite-books/FavoriteBooksView.module.css';
import { HeartIcon, BookIcon } from '../../components/Icons';

const FavoriteBooksView = ({
  books,
  bookMetadata,
  completedChapterCounts,
  loading,
  error,
  onDeleteBook,
  onOpenBookDetail,
}) => {
  if (!books.length) {
    return (
      <div className={styles.noHistory}>
        <div className={styles.noHistoryIcon}>
          <BookIcon size={48} />
        </div>
        <h3>还没有收藏的书籍</h3>
        <p>在书籍详情页点击收藏即可加入书架</p>
      </div>
    );
  }

  return (
    <>
      {loading && <div className={styles.metadataHint}>书籍信息加载中...</div>}
      {error && <div className={styles.metadataError}>{error}</div>}
      <div className={styles.favoriteBookList}>
        {books.map((item) => {
          const meta = bookMetadata[String(item.novel_id)] || {};
          const bookTitle = meta.title || `书籍 ${item.novel_id}`;
          const author = meta.author || '未知作者';
          const description = meta.description || '';
          const createdAt = item.created_at ? new Date(item.created_at).toLocaleString() : '';
          const totalChapters = meta.chapters_count ?? 0;
          const volumesCount = meta.volumes_count ?? (Array.isArray(meta.volumes) ? meta.volumes.length : 0);
          const completedCount = completedChapterCounts[String(item.novel_id)] || 0;
          const progressPercent = totalChapters > 0
            ? Math.min(100, Math.round((completedCount / totalChapters) * 100))
            : 0;
          const progressLabel = totalChapters > 0 ? `${progressPercent}%` : '—';

          return (
            <div
              key={item.id}
              className={styles.favoriteBookCard}
              role="button"
              tabIndex={0}
              onClick={() => onOpenBookDetail(item)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onOpenBookDetail(item);
                }
              }}
            >
              <div className={styles.favoriteBookBody}>
                <div className={styles.favoriteBookHeaderRow}>
                  <div className={styles.favoriteBookMeta}>
                    <h3 className={styles.favoriteBookTitle}>{bookTitle}</h3>
                    <p className={styles.favoriteBookAuthor}>作者：{author}</p>
                    {createdAt && <p className={styles.favoriteBookTime}>收藏于：{createdAt}</p>}
                  </div>
                  <div className={styles.favoriteBookActions}>
                    <button
                      type="button"
                      className={styles.deleteBtn}
                      onClick={(event) => {
                        event.stopPropagation();
                        onDeleteBook(item.id);
                      }}
                      title="取消收藏"
                      aria-label="取消收藏"
                    >
                      <HeartIcon size={18} filled />
                    </button>
                  </div>
                </div>

                {description && (
                  <p className={styles.favoriteBookDescription}>{description}</p>
                )}

                <div className={styles.favoriteBookStatsRow}>
                  <span className={styles.favoriteBookStat}>总章节 {totalChapters}</span>
                  <span className={styles.favoriteBookStat}>已完成 {completedCount}</span>
                  <span className={styles.favoriteBookStat}>卷数 {volumesCount}</span>
                </div>

                <div className={styles.favoriteBookProgress}>
                  <div className={styles.progressBarTrack} aria-hidden="true">
                    <div
                      className={styles.progressBarValue}
                      style={{ width: `${progressPercent}%` }}
                    />
                  </div>
                  <span className={styles.progressLabel}>{progressLabel}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default FavoriteBooksView;

